import { useCallback, useRef } from "react";

export function useOnClickOutside<T extends HTMLElement>(handler: () => void) {
    const destroy = useRef<(() => void) | null>(null);
    return useCallback(
        (targetElement: T | null) => {
            if (destroy.current) {
                destroy.current();
                destroy.current = null;
            }

            if (targetElement === null) {
                return;
            }

            const eventHandler = (event: MouseEvent | TouchEvent) => {
                const targetIsNode = event.target instanceof Node;
                if (!targetIsNode) {
                    return;
                }

                const clickIsInTarget = targetElement.contains(event.target);
                if (!clickIsInTarget) {
                    handler();
                }
            };

            document.addEventListener("mousedown", eventHandler);
            document.addEventListener("touchstart", eventHandler);
            destroy.current = () => {
                document.removeEventListener("touchstart", eventHandler);
                document.removeEventListener("mousedown", eventHandler);
            };
        },
        [handler, destroy],
    );
}
